import { Col, Row } from 'react-bootstrap'

import {
  FREE_SHIPPING_THRESHOLD,
  STORE_RETURNS_THRESHOLD,
} from 'shared/constants'
import css from './why-shop-babylist.scss'
import { StyledSubHeading } from '../../../../components/headings'

const WhyShopBabylist = () => (
  <div className="text-center mtl mbxl">
    <Row>
      <Col xs={12}>
        <StyledSubHeading className="text-bold">
          Why shop with Babylist?
        </StyledSubHeading>
      </Col>
    </Row>
    <Row className={css.valueProps}>
      <Col sm={4} className="pvl">
        <div className="h4 text-bold mvs">
          We only work with <br className="hidden-xs" />
          brands we trust
        </div>
        <p>
          Our little ones are precious. The products we buy for them need to
          perform as promised.
        </p>
      </Col>
      <Col sm={4} className="pvl">
        <div className="h4 text-bold mvs">
          Free shipping + <br className="hidden-xs" />
          Free returns
        </div>
        <p>{`Orders over $${FREE_SHIPPING_THRESHOLD} ship for free.* Return Babylist Shop gifts up to ${STORE_RETURNS_THRESHOLD} after purchase!`}</p>
      </Col>
      <Col sm={4} className="pvl">
        <div className="h4 text-bold mvs">
          Our Happiness <br className="hidden-xs" />
          Heroes Rock
        </div>
        <p>
          Our Happiness Heroes are super knowledgeable about baby products, plus
          they're nice!
        </p>
      </Col>
    </Row>
  </div>
)

export default WhyShopBabylist
